module.exports = __webpack_public_path__ + "assets/packages/operator-lifecycle-manager/src/operator.svg";